import { Pipe, PipeTransform } from '@angular/core';
import { IMultiPrintDevice } from '@multiprint/abstract/multi-print-device';
import { statusPriorities } from '@shared/constants/status-priorities';

@Pipe({
  name: 'multiPrintDeviceStatusSort'
})
export class MultiPrintDeviceStatusSortPipe implements PipeTransform {

  transform(value: IMultiPrintDevice[]): IMultiPrintDevice[] {
    return value.sort((a, b) => {
      return statusPriorities[a.statusCode].priority < statusPriorities[b.statusCode].priority ? -1 : 1;
    });
  }
}
